angular.module('unergie.main')
.factory('EventProcessorService', ($state, MetaWatcher, NotificationService) => {
    let registrations = {}

    const EVENTS = {
        SIGNATURE_ERROR(event) {
            NotificationService.showNotif({
                title: `${event.name} a rencontré un problème`,
                icon: 'signedKO.png',
                body: `Signature en erreur : ${event.error}`,
                delay: 10000,
                type: event.type,
            })
        },
        CONTRACT_SIGNED(event) {
            let body
            if (event.needInter) {
                body = 'Et le contract nécessite une prise de RDV !'
            }
            NotificationService.showNotif({
                title: `${event.name} : contrat signé 🙂`,
                icon: 'sales-tunnel/icon-contract-signed.png',
                body,
                delay: 6000,
                type: event.type,
            })
        },
        RULES_CALLBACK(event) {
            NotificationService.showNotif({
                title: `${event.rule} terminée avec le code ${event.code}`,
                body: 'Cliquez ici pour afficher le résultat',
                delay: 10000,
                result: event.result,
                type: event.type,
            })
        },
        CUSTOM(event) {
            NotificationService.showNotif(event)
        },
        CALL_DONE(event) {
            NotificationService.showNotif({
                title: 'Appel fini',
                body: 'Cliquez ici pour stater le call',
                delay: 15000,
                type: event.type,
                modal: {
                    type: 'logCallModal',
                    size: 'lg',
                    backdrop: 'static',
                    payload: {
                        idAccount: event.id_account,
                        callId: event.callId,
                    },
                },
            })
            if (event.source && (event.source === 'ws')) {
                MetaWatcher.notif('CONTACTS_CHANGED')
            }
        },
        CALL_ANSWERED(event) {
            NotificationService.showNotif({
                title: 'Appel en cours',
                body: 'Un appel est en cours avec ce client, cliquez ici pour ouvrir la fenêtre de commentaires',
                delay: 15000,
                type: event.type,
                modal: {
                    type: 'logCallModal',
                    size: 'lg',
                    backdrop: 'static',
                    payload: {
                        idAccount: event.id_account,
                        callId: event.callId,
                    },
                },
            })
            if (event.source && (event.source === 'ws')) {
                MetaWatcher.notif('CONTACTS_CHANGED')
            }
        },
    }

    const processEvent = function (event) {
        if ((event != null ? event.type : undefined) && EVENTS[event.type]) {
            EVENTS[event.type](event)
        }
        if (registrations[`${event.type}_${event.id}`]) {
            if (event.type === 'PASSWORD') {
                NotificationService.showNotif({
                    title: `${event.name} : mot de passe créé`,
                    icon: 'passwdOK.png',
                    delay: 6000,
                    type: event.type,
                })
            } else if (event.type === 'SUBSCRIPTION_SUMMARY') {
                NotificationService.showNotif({
                    title: `${event.name} : résumé de commande`,
                    icon: 'sales-tunnel/icon-recap-displayed.png',
                    delay: 6000,
                    type: event.type,
                })
            } else if (event.type === 'MANDATE_SIGNATURE') {
                NotificationService.showNotif({
                    title: `${event.name} : signature en cours`,
                    icon: 'sales-tunnel/icon-cgv-checked.png',
                    delay: 6000,
                    type: event.type,
                })
            } else if (event.type === 'EMAIL_BOUNCED') {
                NotificationService.showNotif({
                    title: `${event.name} : l'email semble erroné, on vient de recevoir un mailer-daemon`,
                    icon: 'icon-email.svg',
                    delay: 6000,
                    type: event.type,
                })
            }
            registrations[`${event.type}_${event.id}`](event)
        }
        if (registrations[`${event.type}_ALL`]) {
            registrations[`${event.type}_ALL`](event)
        }
    }

    const register = function (type, id, scope, callback) {
        registrations[`${type}_${id}`] = callback
        return scope.$on('$destroy', () => delete registrations[`${type}_${id}`])
    }

    const unregisterAll = () => {
        registrations = {}
    }

    return {
        processEvent,
        register,
        unregisterAll,
    }
})
